
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as creator_45inquiry5YjTfDTCkmikvKJku_GmE8tO3NKzmcFGBRSrzcFguikMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry.vue?macro=true";
import { default as creator_45inquiry_45centeredCE_8r9QbpmGpVuvvCA_mISm4ZOjF1xgnCOROqQzl13oMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-centered.vue?macro=true";
import { default as creator_45inquiry_45iphonenv3tZeJ0ruhY5gD_ZboHGoJj1pM6eSNX1GzW316m544Meta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-iphone.vue?macro=true";
import { default as creator_45inquiry_45website9a5tKrOJJLCXcWHfgA2Kd_6ktw7JHCZr__UXRbS6wCQMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-website.vue?macro=true";
import { default as _91tool_93urBbV6g_Aopa_5mqwdrxXSlxP9xXpiTn_cxjRVMKRGcMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/embed/tools/[tool].vue?macro=true";
import { default as action36VddPkb3LxcKRcnC1dRKSQt0a6vMF_UfcG3E9TwAjcMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/auth/action.vue?macro=true";
import { default as agency_45management_45softwaret_41eK7FscdYsyvfEd306PU2xvTrqqs_jQCW_mefl_wMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-management-software.vue?macro=true";
import { default as find_45a_45freelancer_KXfMwd14TQgARdUhpASk4qNnkLAcjMCfVG6uunbIJUMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/find-a-freelancer.vue?macro=true";
import { default as ios_Avr7Rfa95ZdQsghgOIszznf27kN_ksoWoka4T1RKQ8Meta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/ios.vue?macro=true";
import { default as index7h6hMeYllJ4MKbsMuR9BzU0k3O7Un_j7hDvJiP9yWZcMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/reset-password/index.vue?macro=true";
import { default as sign_45inozg1oansyfnPrNHRf5j40fjdlzvrHlN_ciKLd9ZoCKwMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sign-in.vue?macro=true";
import { default as sign_45upuGcIjz5mi6FPyj3Kocqf9t_5mgRqAtXMF4Kq7_PWdWQMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sign-up.vue?macro=true";
import { default as startUlto8hDMjrLCKJWGp2ggiL6iNv1cCMKQhpyOZ9RCNyMMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/start.vue?macro=true";
import { default as try4JfxhKQce3wktqrPI5VcaookC8jrNhLAf_bC5xGAXsoMeta } from "/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/try.vue?macro=true";
export default [
  {
    name: "internal-walkthroughs-live-slug",
    path: "/internal/walkthroughs/live/:slug()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/live/[slug].vue")
  },
  {
    name: "internal-walkthroughs-creator-inquiry",
    path: "/internal/walkthroughs/creator-inquiry",
    meta: creator_45inquiry5YjTfDTCkmikvKJku_GmE8tO3NKzmcFGBRSrzcFguikMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry.vue")
  },
  {
    name: "internal-walkthroughs-creator-inquiry-centered",
    path: "/internal/walkthroughs/creator-inquiry-centered",
    meta: creator_45inquiry_45centeredCE_8r9QbpmGpVuvvCA_mISm4ZOjF1xgnCOROqQzl13oMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-centered.vue")
  },
  {
    name: "internal-walkthroughs-creator-inquiry-iphone",
    path: "/internal/walkthroughs/creator-inquiry-iphone",
    meta: creator_45inquiry_45iphonenv3tZeJ0ruhY5gD_ZboHGoJj1pM6eSNX1GzW316m544Meta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-iphone.vue")
  },
  {
    name: "internal-walkthroughs-creator-inquiry-website",
    path: "/internal/walkthroughs/creator-inquiry-website",
    meta: creator_45inquiry_45website9a5tKrOJJLCXcWHfgA2Kd_6ktw7JHCZr__UXRbS6wCQMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/creator-inquiry-website.vue")
  },
  {
    name: "internal-walkthroughs-frames",
    path: "/internal/walkthroughs/frames",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/frames.vue")
  },
  {
    name: "legal-previous-privacy-policy-2026-09-15",
    path: "/legal/previous/privacy-policy-2026-09-15",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/legal/previous/privacy-policy-2026-09-15"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/legal/previous/privacy-policy-2026-09-15.vue")
  },
  {
    name: "legal-previous-terms-of-service-2026-07-30",
    path: "/legal/previous/terms-of-service-2026-07-30",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/legal/previous/terms-of-service-2026-07-30"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/legal/previous/terms-of-service-2026-07-30.vue")
  },
  {
    name: "changelog-area-area",
    path: "/changelog/area/:area()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/changelog/area/:area()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/changelog/area/[area].vue")
  },
  {
    name: "embed-tools-tool",
    path: "/embed/tools/:tool()",
    meta: _91tool_93urBbV6g_Aopa_5mqwdrxXSlxP9xXpiTn_cxjRVMKRGcMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/embed/tools/[tool].vue")
  },
  {
    name: "internal-blog-designs-variant",
    path: "/internal/blog-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/blog-designs/[variant].vue")
  },
  {
    name: "internal-compare-designs-variant",
    path: "/internal/compare-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/compare-designs/[variant].vue")
  },
  {
    name: "internal-integration-designs-variant",
    path: "/internal/integration-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/integration-designs/[variant].vue")
  },
  {
    name: "internal-mcp-board-designs-variant",
    path: "/internal/mcp-board-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/mcp-board-designs/[variant].vue")
  },
  {
    name: "internal-support-designs-variant",
    path: "/internal/support-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/support-designs/[variant].vue")
  },
  {
    name: "internal-tool-designs-variant",
    path: "/internal/tool-designs/:variant()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/tool-designs/[variant].vue")
  },
  {
    name: "internal-walkthroughs-slug",
    path: "/internal/walkthroughs/:slug()",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/[slug].vue")
  },
  {
    name: "learn-topics-slug",
    path: "/learn/topics/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/learn/topics/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/learn/topics/[slug].vue")
  },
  {
    name: "auth-action",
    path: "/auth/action",
    meta: action36VddPkb3LxcKRcnC1dRKSQt0a6vMF_UfcG3E9TwAjcMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/auth/action.vue")
  },
  {
    name: "compare-17hats",
    path: "/compare/17hats",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/17hats"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/17hats.vue")
  },
  {
    name: "compare-accelo",
    path: "/compare/accelo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/accelo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/accelo.vue")
  },
  {
    name: "compare-airtable",
    path: "/compare/airtable",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/airtable"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/airtable.vue")
  },
  {
    name: "compare-asana",
    path: "/compare/asana",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/asana"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/asana.vue")
  },
  {
    name: "compare-basecamp",
    path: "/compare/basecamp",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/basecamp"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/basecamp.vue")
  },
  {
    name: "compare-bigin",
    path: "/compare/bigin",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/bigin"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/bigin.vue")
  },
  {
    name: "compare-bloom",
    path: "/compare/bloom",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/bloom"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/bloom.vue")
  },
  {
    name: "compare-bonsai",
    path: "/compare/bonsai",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/bonsai"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/bonsai.vue")
  },
  {
    name: "compare-capsule-crm",
    path: "/compare/capsule-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/capsule-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/capsule-crm.vue")
  },
  {
    name: "compare-clickup",
    path: "/compare/clickup",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/clickup"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/clickup.vue")
  },
  {
    name: "compare-copilot",
    path: "/compare/copilot",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/copilot"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/copilot.vue")
  },
  {
    name: "compare-dialpad",
    path: "/compare/dialpad",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/dialpad"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/dialpad.vue")
  },
  {
    name: "compare-dubsado",
    path: "/compare/dubsado",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/dubsado"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/dubsado.vue")
  },
  {
    name: "compare-freshbooks",
    path: "/compare/freshbooks",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/freshbooks"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/freshbooks.vue")
  },
  {
    name: "compare-gohighlevel",
    path: "/compare/gohighlevel",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/gohighlevel"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/gohighlevel.vue")
  },
  {
    name: "compare-google-voice",
    path: "/compare/google-voice",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/google-voice"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/google-voice.vue")
  },
  {
    name: "compare-google-workspace-spreadsheets",
    path: "/compare/google-workspace-spreadsheets",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/google-workspace-spreadsheets"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/google-workspace-spreadsheets.vue")
  },
  {
    name: "compare-harvest",
    path: "/compare/harvest",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/harvest"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/harvest.vue")
  },
  {
    name: "compare-honeybook",
    path: "/compare/honeybook",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/honeybook"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/honeybook.vue")
  },
  {
    name: "compare-honeybook-vs-dubsado",
    path: "/compare/honeybook-vs-dubsado",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/honeybook-vs-dubsado"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/honeybook-vs-dubsado.vue")
  },
  {
    name: "compare-hubspot",
    path: "/compare/hubspot",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/hubspot"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/hubspot.vue")
  },
  {
    name: "compare-insightly",
    path: "/compare/insightly",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/insightly"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/insightly.vue")
  },
  {
    name: "compare-intercom",
    path: "/compare/intercom",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/intercom"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/intercom.vue")
  },
  {
    name: "compare-invoice-ninja",
    path: "/compare/invoice-ninja",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/invoice-ninja"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/invoice-ninja.vue")
  },
  {
    name: "compare-jira",
    path: "/compare/jira",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/jira"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/jira.vue")
  },
  {
    name: "compare-kantata",
    path: "/compare/kantata",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/kantata"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/kantata.vue")
  },
  {
    name: "compare-keap",
    path: "/compare/keap",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/keap"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/keap.vue")
  },
  {
    name: "compare-less-annoying-crm",
    path: "/compare/less-annoying-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/less-annoying-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/less-annoying-crm.vue")
  },
  {
    name: "compare-monday-com",
    path: "/compare/monday-com",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/monday-com"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/monday-com.vue")
  },
  {
    name: "compare-motion",
    path: "/compare/motion",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/motion"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/motion.vue")
  },
  {
    name: "compare-moxie",
    path: "/compare/moxie",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/moxie"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/moxie.vue")
  },
  {
    name: "compare-nextiva",
    path: "/compare/nextiva",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/nextiva"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/nextiva.vue")
  },
  {
    name: "compare-notion",
    path: "/compare/notion",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/notion"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/notion.vue")
  },
  {
    name: "compare-paymo",
    path: "/compare/paymo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/paymo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/paymo.vue")
  },
  {
    name: "compare-pipedrive",
    path: "/compare/pipedrive",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/pipedrive"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/pipedrive.vue")
  },
  {
    name: "compare-plutio",
    path: "/compare/plutio",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/plutio"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/plutio.vue")
  },
  {
    name: "compare-quickbooks",
    path: "/compare/quickbooks",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/quickbooks"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/quickbooks.vue")
  },
  {
    name: "compare-quickbooks-solopreneur",
    path: "/compare/quickbooks-solopreneur",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/quickbooks-solopreneur"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/quickbooks-solopreneur.vue")
  },
  {
    name: "compare-quo",
    path: "/compare/quo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/quo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/quo.vue")
  },
  {
    name: "compare-replace-your-software-stack",
    path: "/compare/replace-your-software-stack",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/replace-your-software-stack"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/replace-your-software-stack.vue")
  },
  {
    name: "compare-ringcentral",
    path: "/compare/ringcentral",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/ringcentral"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/ringcentral.vue")
  },
  {
    name: "compare-salesforce",
    path: "/compare/salesforce",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/salesforce"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/salesforce.vue")
  },
  {
    name: "compare-scoro",
    path: "/compare/scoro",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/scoro"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/scoro.vue")
  },
  {
    name: "compare-smartsheet",
    path: "/compare/smartsheet",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/smartsheet"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/smartsheet.vue")
  },
  {
    name: "compare-square-appointments",
    path: "/compare/square-appointments",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/square-appointments"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/square-appointments.vue")
  },
  {
    name: "compare-teamwork",
    path: "/compare/teamwork",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/teamwork"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/teamwork.vue")
  },
  {
    name: "compare-thryv",
    path: "/compare/thryv",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/thryv"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/thryv.vue")
  },
  {
    name: "compare-traveljoy",
    path: "/compare/traveljoy",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/traveljoy"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/traveljoy.vue")
  },
  {
    name: "compare-trello",
    path: "/compare/trello",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/trello"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/trello.vue")
  },
  {
    name: "compare-vacationcrm",
    path: "/compare/vacationcrm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/vacationcrm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/vacationcrm.vue")
  },
  {
    name: "compare-wave",
    path: "/compare/wave",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/wave"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/wave.vue")
  },
  {
    name: "compare-wrike",
    path: "/compare/wrike",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/wrike"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/wrike.vue")
  },
  {
    name: "compare-xero",
    path: "/compare/xero",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/xero"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/xero.vue")
  },
  {
    name: "compare-zendesk",
    path: "/compare/zendesk",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/zendesk"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/zendesk.vue")
  },
  {
    name: "compare-zilo",
    path: "/compare/zilo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/zilo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/zilo.vue")
  },
  {
    name: "compare-zoho-crm",
    path: "/compare/zoho-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/zoho-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/zoho-crm.vue")
  },
  {
    name: "compare-zoho-projects",
    path: "/compare/zoho-projects",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/zoho-projects"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/zoho-projects.vue")
  },
  {
    name: "compare-zoomscheduler",
    path: "/compare/zoomscheduler",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare/zoomscheduler"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/zoomscheduler.vue")
  },
  {
    name: "features-accounting",
    path: "/features/accounting",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/accounting"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/accounting.vue")
  },
  {
    name: "features-ai-chat",
    path: "/features/ai-chat",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/ai-chat"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/ai-chat.vue")
  },
  {
    name: "features-analytics",
    path: "/features/analytics",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/analytics"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/analytics.vue")
  },
  {
    name: "features-auto-attendant-and-ivr",
    path: "/features/auto-attendant-and-ivr",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/auto-attendant-and-ivr"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/auto-attendant-and-ivr.vue")
  },
  {
    name: "features-automation",
    path: "/features/automation",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/automation"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/automation.vue")
  },
  {
    name: "features-autopilot",
    path: "/features/autopilot",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/autopilot"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/autopilot.vue")
  },
  {
    name: "features-branding",
    path: "/features/branding",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/branding"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/branding.vue")
  },
  {
    name: "features-change-orders",
    path: "/features/change-orders",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/change-orders"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/change-orders.vue")
  },
  {
    name: "features-client-portal",
    path: "/features/client-portal",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/client-portal"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/client-portal.vue")
  },
  {
    name: "features-client-scoped-access",
    path: "/features/client-scoped-access",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/client-scoped-access"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/client-scoped-access.vue")
  },
  {
    name: "features-communications",
    path: "/features/communications",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/communications"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/communications.vue")
  },
  {
    name: "features-contracts",
    path: "/features/contracts",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/contracts"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/contracts.vue")
  },
  {
    name: "features-expenses",
    path: "/features/expenses",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/expenses"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/expenses.vue")
  },
  {
    name: "features-files",
    path: "/features/files",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/files"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/files.vue")
  },
  {
    name: "features-invoices",
    path: "/features/invoices",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/invoices"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/invoices.vue")
  },
  {
    name: "features-looks",
    path: "/features/looks",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/looks"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/looks.vue")
  },
  {
    name: "features-mobile-app",
    path: "/features/mobile-app",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/mobile-app"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/mobile-app.vue")
  },
  {
    name: "features-multi-currency-invoicing",
    path: "/features/multi-currency-invoicing",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/multi-currency-invoicing"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/multi-currency-invoicing.vue")
  },
  {
    name: "features-online-booking",
    path: "/features/online-booking",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/online-booking"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/online-booking.vue")
  },
  {
    name: "features-payments",
    path: "/features/payments",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/payments"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/payments.vue")
  },
  {
    name: "features-pdf-customization",
    path: "/features/pdf-customization",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/pdf-customization"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/pdf-customization.vue")
  },
  {
    name: "features-post-call-automation",
    path: "/features/post-call-automation",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/post-call-automation"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/post-call-automation.vue")
  },
  {
    name: "features-products",
    path: "/features/products",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/products"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/products.vue")
  },
  {
    name: "features-quoting",
    path: "/features/quoting",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/quoting"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/quoting.vue")
  },
  {
    name: "features-retainers-and-recurring-billing",
    path: "/features/retainers-and-recurring-billing",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/retainers-and-recurring-billing"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/retainers-and-recurring-billing.vue")
  },
  {
    name: "features-schedule",
    path: "/features/schedule",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/schedule"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/schedule.vue")
  },
  {
    name: "features-support",
    path: "/features/support",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/support"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/support.vue")
  },
  {
    name: "features-themes",
    path: "/features/themes",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/themes"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/themes.vue")
  },
  {
    name: "features-time-tracking",
    path: "/features/time-tracking",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/time-tracking"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/time-tracking.vue")
  },
  {
    name: "features-workspace-voice",
    path: "/features/workspace-voice",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features/workspace-voice"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/workspace-voice.vue")
  },
  {
    name: "internal-authority-pack",
    path: "/internal/authority-pack",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/authority-pack.vue")
  },
  {
    name: "internal-blog-designs",
    path: "/internal/blog-designs",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/blog-designs/index.vue")
  },
  {
    name: "internal-component-library",
    path: "/internal/component-library",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/component-library.vue")
  },
  {
    name: "internal-conversion-map",
    path: "/internal/conversion-map",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/conversion-map.vue")
  },
  {
    name: "internal-customer-proof-mockup",
    path: "/internal/customer-proof-mockup",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/customer-proof-mockup.vue")
  },
  {
    name: "internal-illustrations",
    path: "/internal/illustrations",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/illustrations.vue")
  },
  {
    name: "internal-late-payment-study",
    path: "/internal/late-payment-study",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/late-payment-study.vue")
  },
  {
    name: "internal-walkthroughs",
    path: "/internal/walkthroughs",
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/internal/walkthroughs/index.vue")
  },
  {
    name: "research-service-pricing-study",
    path: "/research/service-pricing-study",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/research/service-pricing-study"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/research/service-pricing-study.vue")
  },
  {
    name: "solutions-account-management-software-for-agencies",
    path: "/solutions/account-management-software-for-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/account-management-software-for-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/account-management-software-for-agencies.vue")
  },
  {
    name: "solutions-agency-crm",
    path: "/solutions/agency-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/agency-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-crm.vue")
  },
  {
    name: "solutions-agency-management-software",
    path: "/solutions/agency-management-software",
    meta: agency_45management_45softwaret_41eK7FscdYsyvfEd306PU2xvTrqqs_jQCW_mefl_wMeta || {},
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/agency-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-management-software.vue")
  },
  {
    name: "solutions-agency-project-management-software",
    path: "/solutions/agency-project-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/agency-project-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-project-management-software.vue")
  },
  {
    name: "solutions-agency-software-flat-pricing",
    path: "/solutions/agency-software-flat-pricing",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/agency-software-flat-pricing"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-software-flat-pricing.vue")
  },
  {
    name: "solutions-agency-time-tracking-software",
    path: "/solutions/agency-time-tracking-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/agency-time-tracking-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/agency-time-tracking-software.vue")
  },
  {
    name: "solutions-ai-call-summary-software",
    path: "/solutions/ai-call-summary-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/ai-call-summary-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/ai-call-summary-software.vue")
  },
  {
    name: "solutions-architecture-firm-software",
    path: "/solutions/architecture-firm-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/architecture-firm-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/architecture-firm-software.vue")
  },
  {
    name: "solutions-bookkeeping-practice-management-software",
    path: "/solutions/bookkeeping-practice-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/bookkeeping-practice-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/bookkeeping-practice-management-software.vue")
  },
  {
    name: "solutions-business-phone-system-with-crm",
    path: "/solutions/business-phone-system-with-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/business-phone-system-with-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/business-phone-system-with-crm.vue")
  },
  {
    name: "solutions-client-intake-form-software",
    path: "/solutions/client-intake-form-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-intake-form-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-intake-form-software.vue")
  },
  {
    name: "solutions-client-management-software",
    path: "/solutions/client-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-management-software.vue")
  },
  {
    name: "solutions-client-onboarding-software",
    path: "/solutions/client-onboarding-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-onboarding-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-onboarding-software.vue")
  },
  {
    name: "solutions-client-portal-and-billing-software",
    path: "/solutions/client-portal-and-billing-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-portal-and-billing-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-portal-and-billing-software.vue")
  },
  {
    name: "solutions-client-portal-for-agencies",
    path: "/solutions/client-portal-for-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-portal-for-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-portal-for-agencies.vue")
  },
  {
    name: "solutions-client-portal-for-freelancers",
    path: "/solutions/client-portal-for-freelancers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-portal-for-freelancers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-portal-for-freelancers.vue")
  },
  {
    name: "solutions-client-work-operating-system",
    path: "/solutions/client-work-operating-system",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/client-work-operating-system"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/client-work-operating-system.vue")
  },
  {
    name: "solutions-coaching-business-software",
    path: "/solutions/coaching-business-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/coaching-business-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/coaching-business-software.vue")
  },
  {
    name: "solutions-consulting-firm-software",
    path: "/solutions/consulting-firm-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/consulting-firm-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/consulting-firm-software.vue")
  },
  {
    name: "solutions-contract-and-invoice-software-for-freelancers",
    path: "/solutions/contract-and-invoice-software-for-freelancers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/contract-and-invoice-software-for-freelancers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/contract-and-invoice-software-for-freelancers.vue")
  },
  {
    name: "solutions-creative-agency-project-management-software",
    path: "/solutions/creative-agency-project-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/creative-agency-project-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/creative-agency-project-management-software.vue")
  },
  {
    name: "solutions-crm-for-ai-automation-agencies",
    path: "/solutions/crm-for-ai-automation-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-ai-automation-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-ai-automation-agencies.vue")
  },
  {
    name: "solutions-crm-for-app-development-agencies",
    path: "/solutions/crm-for-app-development-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-app-development-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-app-development-agencies.vue")
  },
  {
    name: "solutions-crm-for-barbershops",
    path: "/solutions/crm-for-barbershops",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-barbershops"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-barbershops.vue")
  },
  {
    name: "solutions-crm-for-branding-agencies",
    path: "/solutions/crm-for-branding-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-branding-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-branding-agencies.vue")
  },
  {
    name: "solutions-crm-for-business-coaches",
    path: "/solutions/crm-for-business-coaches",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-business-coaches"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-business-coaches.vue")
  },
  {
    name: "solutions-crm-for-business-scaling-growth-programs",
    path: "/solutions/crm-for-business-scaling-growth-programs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-business-scaling-growth-programs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-business-scaling-growth-programs.vue")
  },
  {
    name: "solutions-crm-for-caterers",
    path: "/solutions/crm-for-caterers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-caterers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-caterers.vue")
  },
  {
    name: "solutions-crm-for-chiropractors",
    path: "/solutions/crm-for-chiropractors",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-chiropractors"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-chiropractors.vue")
  },
  {
    name: "solutions-crm-for-coaching-programs-high-ticket",
    path: "/solutions/crm-for-coaching-programs-high-ticket",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-coaching-programs-high-ticket"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-coaching-programs-high-ticket.vue")
  },
  {
    name: "solutions-crm-for-commercial-product-photographers",
    path: "/solutions/crm-for-commercial-product-photographers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-commercial-product-photographers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-commercial-product-photographers.vue")
  },
  {
    name: "solutions-crm-for-consultants",
    path: "/solutions/crm-for-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-consultants.vue")
  },
  {
    name: "solutions-crm-for-content-marketing-agencies",
    path: "/solutions/crm-for-content-marketing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-content-marketing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-content-marketing-agencies.vue")
  },
  {
    name: "solutions-crm-for-copywriters",
    path: "/solutions/crm-for-copywriters",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-copywriters"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-copywriters.vue")
  },
  {
    name: "solutions-crm-for-custom-manufacturers",
    path: "/solutions/crm-for-custom-manufacturers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-custom-manufacturers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-custom-manufacturers.vue")
  },
  {
    name: "solutions-crm-for-cybersecurity-consultants",
    path: "/solutions/crm-for-cybersecurity-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-cybersecurity-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-cybersecurity-consultants.vue")
  },
  {
    name: "solutions-crm-for-djs",
    path: "/solutions/crm-for-djs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-djs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-djs.vue")
  },
  {
    name: "solutions-crm-for-dog-trainers",
    path: "/solutions/crm-for-dog-trainers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-dog-trainers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-dog-trainers.vue")
  },
  {
    name: "solutions-crm-for-drafting-and-cad-services",
    path: "/solutions/crm-for-drafting-and-cad-services",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-drafting-and-cad-services"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-drafting-and-cad-services.vue")
  },
  {
    name: "solutions-crm-for-e-commerce-brands",
    path: "/solutions/crm-for-e-commerce-brands",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-e-commerce-brands"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-e-commerce-brands.vue")
  },
  {
    name: "solutions-crm-for-email-marketing-agencies",
    path: "/solutions/crm-for-email-marketing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-email-marketing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-email-marketing-agencies.vue")
  },
  {
    name: "solutions-crm-for-engineering-firms",
    path: "/solutions/crm-for-engineering-firms",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-engineering-firms"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-engineering-firms.vue")
  },
  {
    name: "solutions-crm-for-estheticians",
    path: "/solutions/crm-for-estheticians",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-estheticians"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-estheticians.vue")
  },
  {
    name: "solutions-crm-for-etsy-and-handmade-sellers",
    path: "/solutions/crm-for-etsy-and-handmade-sellers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-etsy-and-handmade-sellers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-etsy-and-handmade-sellers.vue")
  },
  {
    name: "solutions-crm-for-event-venues",
    path: "/solutions/crm-for-event-venues",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-event-venues"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-event-venues.vue")
  },
  {
    name: "solutions-crm-for-executive-coaches",
    path: "/solutions/crm-for-executive-coaches",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-executive-coaches"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-executive-coaches.vue")
  },
  {
    name: "solutions-crm-for-financial-advisors",
    path: "/solutions/crm-for-financial-advisors",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-financial-advisors"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-financial-advisors.vue")
  },
  {
    name: "solutions-crm-for-fitness-coaches-and-online-fitness-programs",
    path: "/solutions/crm-for-fitness-coaches-and-online-fitness-programs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-fitness-coaches-and-online-fitness-programs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-fitness-coaches-and-online-fitness-programs.vue")
  },
  {
    name: "solutions-crm-for-florists",
    path: "/solutions/crm-for-florists",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-florists"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-florists.vue")
  },
  {
    name: "solutions-crm-for-fractional-executives-cmo-cfo-coo",
    path: "/solutions/crm-for-fractional-executives-cmo-cfo-coo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-fractional-executives-cmo-cfo-coo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-fractional-executives-cmo-cfo-coo.vue")
  },
  {
    name: "solutions-crm-for-freelance-developers",
    path: "/solutions/crm-for-freelance-developers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-freelance-developers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-freelance-developers.vue")
  },
  {
    name: "solutions-crm-for-freelancers",
    path: "/solutions/crm-for-freelancers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-freelancers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-freelancers.vue")
  },
  {
    name: "solutions-crm-for-google-workspace",
    path: "/solutions/crm-for-google-workspace",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-google-workspace"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-google-workspace.vue")
  },
  {
    name: "solutions-crm-for-graphic-designers",
    path: "/solutions/crm-for-graphic-designers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-graphic-designers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-graphic-designers.vue")
  },
  {
    name: "solutions-crm-for-growth-growth-operator-agencies",
    path: "/solutions/crm-for-growth-growth-operator-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-growth-growth-operator-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-growth-growth-operator-agencies.vue")
  },
  {
    name: "solutions-crm-for-gyms-and-boutique-fitness",
    path: "/solutions/crm-for-gyms-and-boutique-fitness",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-gyms-and-boutique-fitness"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-gyms-and-boutique-fitness.vue")
  },
  {
    name: "solutions-crm-for-hair-salons",
    path: "/solutions/crm-for-hair-salons",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-hair-salons"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-hair-salons.vue")
  },
  {
    name: "solutions-crm-for-health-and-nutrition-coaches",
    path: "/solutions/crm-for-health-and-nutrition-coaches",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-health-and-nutrition-coaches"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-health-and-nutrition-coaches.vue")
  },
  {
    name: "solutions-crm-for-home-stagers",
    path: "/solutions/crm-for-home-stagers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-home-stagers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-home-stagers.vue")
  },
  {
    name: "solutions-crm-for-hr-consultants",
    path: "/solutions/crm-for-hr-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-hr-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-hr-consultants.vue")
  },
  {
    name: "solutions-crm-for-illustrators",
    path: "/solutions/crm-for-illustrators",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-illustrators"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-illustrators.vue")
  },
  {
    name: "solutions-crm-for-influencer-marketing-agencies",
    path: "/solutions/crm-for-influencer-marketing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-influencer-marketing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-influencer-marketing-agencies.vue")
  },
  {
    name: "solutions-crm-for-info-product-sellers",
    path: "/solutions/crm-for-info-product-sellers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-info-product-sellers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-info-product-sellers.vue")
  },
  {
    name: "solutions-crm-for-insurance-agents",
    path: "/solutions/crm-for-insurance-agents",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-insurance-agents"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-insurance-agents.vue")
  },
  {
    name: "solutions-crm-for-landscape-architects",
    path: "/solutions/crm-for-landscape-architects",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-landscape-architects"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-landscape-architects.vue")
  },
  {
    name: "solutions-crm-for-lash-and-brow-artists",
    path: "/solutions/crm-for-lash-and-brow-artists",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-lash-and-brow-artists"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-lash-and-brow-artists.vue")
  },
  {
    name: "solutions-crm-for-lead-generation-agencies",
    path: "/solutions/crm-for-lead-generation-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-lead-generation-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-lead-generation-agencies.vue")
  },
  {
    name: "solutions-crm-for-life-coaches",
    path: "/solutions/crm-for-life-coaches",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-life-coaches"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-life-coaches.vue")
  },
  {
    name: "solutions-crm-for-live-bands-and-entertainers",
    path: "/solutions/crm-for-live-bands-and-entertainers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-live-bands-and-entertainers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-live-bands-and-entertainers.vue")
  },
  {
    name: "solutions-crm-for-makeup-artists",
    path: "/solutions/crm-for-makeup-artists",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-makeup-artists"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-makeup-artists.vue")
  },
  {
    name: "solutions-crm-for-management-consultants",
    path: "/solutions/crm-for-management-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-management-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-management-consultants.vue")
  },
  {
    name: "solutions-crm-for-marketing-consultants",
    path: "/solutions/crm-for-marketing-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-marketing-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-marketing-consultants.vue")
  },
  {
    name: "solutions-crm-for-massage-therapists",
    path: "/solutions/crm-for-massage-therapists",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-massage-therapists"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-massage-therapists.vue")
  },
  {
    name: "solutions-crm-for-masterminds",
    path: "/solutions/crm-for-masterminds",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-masterminds"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-masterminds.vue")
  },
  {
    name: "solutions-crm-for-med-spas",
    path: "/solutions/crm-for-med-spas",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-med-spas"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-med-spas.vue")
  },
  {
    name: "solutions-crm-for-membership-communities",
    path: "/solutions/crm-for-membership-communities",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-membership-communities"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-membership-communities.vue")
  },
  {
    name: "solutions-crm-for-mortgage-brokers",
    path: "/solutions/crm-for-mortgage-brokers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-mortgage-brokers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-mortgage-brokers.vue")
  },
  {
    name: "solutions-crm-for-motion-designers-and-animators",
    path: "/solutions/crm-for-motion-designers-and-animators",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-motion-designers-and-animators"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-motion-designers-and-animators.vue")
  },
  {
    name: "solutions-crm-for-music-producers-and-audio-engineers",
    path: "/solutions/crm-for-music-producers-and-audio-engineers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-music-producers-and-audio-engineers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-music-producers-and-audio-engineers.vue")
  },
  {
    name: "solutions-crm-for-nail-salons",
    path: "/solutions/crm-for-nail-salons",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-nail-salons"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-nail-salons.vue")
  },
  {
    name: "solutions-crm-for-no-code-low-code-agencies",
    path: "/solutions/crm-for-no-code-low-code-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-no-code-low-code-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-no-code-low-code-agencies.vue")
  },
  {
    name: "solutions-crm-for-nutritionists-and-dietitians",
    path: "/solutions/crm-for-nutritionists-and-dietitians",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-nutritionists-and-dietitians"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-nutritionists-and-dietitians.vue")
  },
  {
    name: "solutions-crm-for-online-course-creators",
    path: "/solutions/crm-for-online-course-creators",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-online-course-creators"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-online-course-creators.vue")
  },
  {
    name: "solutions-crm-for-party-and-event-rental-companies",
    path: "/solutions/crm-for-party-and-event-rental-companies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-party-and-event-rental-companies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-party-and-event-rental-companies.vue")
  },
  {
    name: "solutions-crm-for-performance-marketing-agencies",
    path: "/solutions/crm-for-performance-marketing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-performance-marketing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-performance-marketing-agencies.vue")
  },
  {
    name: "solutions-crm-for-pet-sitters-and-dog-walkers",
    path: "/solutions/crm-for-pet-sitters-and-dog-walkers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-pet-sitters-and-dog-walkers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-pet-sitters-and-dog-walkers.vue")
  },
  {
    name: "solutions-crm-for-photo-booth-companies",
    path: "/solutions/crm-for-photo-booth-companies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-photo-booth-companies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-photo-booth-companies.vue")
  },
  {
    name: "solutions-crm-for-podcast-producers",
    path: "/solutions/crm-for-podcast-producers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-podcast-producers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-podcast-producers.vue")
  },
  {
    name: "solutions-crm-for-portrait-and-family-photographers",
    path: "/solutions/crm-for-portrait-and-family-photographers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-portrait-and-family-photographers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-portrait-and-family-photographers.vue")
  },
  {
    name: "solutions-crm-for-ppc-paid-ads-agencies",
    path: "/solutions/crm-for-ppc-paid-ads-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-ppc-paid-ads-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-ppc-paid-ads-agencies.vue")
  },
  {
    name: "solutions-crm-for-print-on-demand-businesses",
    path: "/solutions/crm-for-print-on-demand-businesses",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-print-on-demand-businesses"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-print-on-demand-businesses.vue")
  },
  {
    name: "solutions-crm-for-property-managers",
    path: "/solutions/crm-for-property-managers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-property-managers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-property-managers.vue")
  },
  {
    name: "solutions-crm-for-real-estate-agents",
    path: "/solutions/crm-for-real-estate-agents",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-real-estate-agents"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-real-estate-agents.vue")
  },
  {
    name: "solutions-crm-for-real-estate-brokerages",
    path: "/solutions/crm-for-real-estate-brokerages",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-real-estate-brokerages"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-real-estate-brokerages.vue")
  },
  {
    name: "solutions-crm-for-real-estate-investing-education-programs",
    path: "/solutions/crm-for-real-estate-investing-education-programs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-real-estate-investing-education-programs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-real-estate-investing-education-programs.vue")
  },
  {
    name: "solutions-crm-for-real-estate-photographers",
    path: "/solutions/crm-for-real-estate-photographers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-real-estate-photographers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-real-estate-photographers.vue")
  },
  {
    name: "solutions-crm-for-recruiters-and-staffing-agencies",
    path: "/solutions/crm-for-recruiters-and-staffing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-recruiters-and-staffing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-recruiters-and-staffing-agencies.vue")
  },
  {
    name: "solutions-crm-for-sales-training-programs",
    path: "/solutions/crm-for-sales-training-programs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-sales-training-programs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-sales-training-programs.vue")
  },
  {
    name: "solutions-crm-for-shopify-e-commerce-developers",
    path: "/solutions/crm-for-shopify-e-commerce-developers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-shopify-e-commerce-developers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-shopify-e-commerce-developers.vue")
  },
  {
    name: "solutions-crm-for-shopify-store-owners",
    path: "/solutions/crm-for-shopify-store-owners",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-shopify-store-owners"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-shopify-store-owners.vue")
  },
  {
    name: "solutions-crm-for-short-term-rental-managers",
    path: "/solutions/crm-for-short-term-rental-managers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-short-term-rental-managers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-short-term-rental-managers.vue")
  },
  {
    name: "solutions-crm-for-small-agencies",
    path: "/solutions/crm-for-small-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-small-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-small-agencies.vue")
  },
  {
    name: "solutions-crm-for-social-media-marketing-agencies",
    path: "/solutions/crm-for-social-media-marketing-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-social-media-marketing-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-social-media-marketing-agencies.vue")
  },
  {
    name: "solutions-crm-for-software-consultancies",
    path: "/solutions/crm-for-software-consultancies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-software-consultancies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-software-consultancies.vue")
  },
  {
    name: "solutions-crm-for-solo-and-small-law-firms",
    path: "/solutions/crm-for-solo-and-small-law-firms",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-solo-and-small-law-firms"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-solo-and-small-law-firms.vue")
  },
  {
    name: "solutions-crm-for-solopreneurs",
    path: "/solutions/crm-for-solopreneurs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-solopreneurs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-solopreneurs.vue")
  },
  {
    name: "solutions-crm-for-subscription-box-companies",
    path: "/solutions/crm-for-subscription-box-companies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-subscription-box-companies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-subscription-box-companies.vue")
  },
  {
    name: "solutions-crm-for-tattoo-studios",
    path: "/solutions/crm-for-tattoo-studios",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-tattoo-studios"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-tattoo-studios.vue")
  },
  {
    name: "solutions-crm-for-tax-preparers",
    path: "/solutions/crm-for-tax-preparers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-tax-preparers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-tax-preparers.vue")
  },
  {
    name: "solutions-crm-for-trading-and-investing-education-programs",
    path: "/solutions/crm-for-trading-and-investing-education-programs",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-trading-and-investing-education-programs"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-trading-and-investing-education-programs.vue")
  },
  {
    name: "solutions-crm-for-ux-ui-designers",
    path: "/solutions/crm-for-ux-ui-designers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-ux-ui-designers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-ux-ui-designers.vue")
  },
  {
    name: "solutions-crm-for-video-editors",
    path: "/solutions/crm-for-video-editors",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-video-editors"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-video-editors.vue")
  },
  {
    name: "solutions-crm-for-virtual-assistants",
    path: "/solutions/crm-for-virtual-assistants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-virtual-assistants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-virtual-assistants.vue")
  },
  {
    name: "solutions-crm-for-voice-over-artists",
    path: "/solutions/crm-for-voice-over-artists",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-voice-over-artists"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-voice-over-artists.vue")
  },
  {
    name: "solutions-crm-for-web-designers",
    path: "/solutions/crm-for-web-designers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-web-designers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-web-designers.vue")
  },
  {
    name: "solutions-crm-for-web-development-agencies",
    path: "/solutions/crm-for-web-development-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-web-development-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-web-development-agencies.vue")
  },
  {
    name: "solutions-crm-for-wedding-photographers",
    path: "/solutions/crm-for-wedding-photographers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-wedding-photographers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-wedding-photographers.vue")
  },
  {
    name: "solutions-crm-for-wedding-planners",
    path: "/solutions/crm-for-wedding-planners",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-wedding-planners"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-wedding-planners.vue")
  },
  {
    name: "solutions-crm-for-wedding-videographers",
    path: "/solutions/crm-for-wedding-videographers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-wedding-videographers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-wedding-videographers.vue")
  },
  {
    name: "solutions-crm-for-wholesalers-and-distributors",
    path: "/solutions/crm-for-wholesalers-and-distributors",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-wholesalers-and-distributors"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-wholesalers-and-distributors.vue")
  },
  {
    name: "solutions-crm-for-yoga-and-pilates-studios",
    path: "/solutions/crm-for-yoga-and-pilates-studios",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/crm-for-yoga-and-pilates-studios"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/crm-for-yoga-and-pilates-studios.vue")
  },
  {
    name: "solutions-dog-grooming-software",
    path: "/solutions/dog-grooming-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/dog-grooming-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/dog-grooming-software.vue")
  },
  {
    name: "solutions-driving-school-software",
    path: "/solutions/driving-school-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/driving-school-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/driving-school-software.vue")
  },
  {
    name: "solutions-event-planning-software",
    path: "/solutions/event-planning-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/event-planning-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/event-planning-software.vue")
  },
  {
    name: "solutions-expense-tracking-software-for-freelancers",
    path: "/solutions/expense-tracking-software-for-freelancers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/expense-tracking-software-for-freelancers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/expense-tracking-software-for-freelancers.vue")
  },
  {
    name: "solutions-freelance-business-software",
    path: "/solutions/freelance-business-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/freelance-business-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/freelance-business-software.vue")
  },
  {
    name: "solutions-freelance-project-management-software",
    path: "/solutions/freelance-project-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/freelance-project-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/freelance-project-management-software.vue")
  },
  {
    name: "solutions-freelancer-invoicing-software",
    path: "/solutions/freelancer-invoicing-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/freelancer-invoicing-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/freelancer-invoicing-software.vue")
  },
  {
    name: "solutions-funnel-builder-with-crm",
    path: "/solutions/funnel-builder-with-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/funnel-builder-with-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/funnel-builder-with-crm.vue")
  },
  {
    name: "solutions-goals",
    path: "/solutions/goals",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/goals"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/goals.vue")
  },
  {
    name: "solutions-google-voice-alternative",
    path: "/solutions/google-voice-alternative",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/google-voice-alternative"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/google-voice-alternative.vue")
  },
  {
    name: "solutions-group-texting-software",
    path: "/solutions/group-texting-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/group-texting-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/group-texting-software.vue")
  },
  {
    name: "solutions-interior-design-software",
    path: "/solutions/interior-design-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/interior-design-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/interior-design-software.vue")
  },
  {
    name: "solutions-invoicing-and-project-management-software",
    path: "/solutions/invoicing-and-project-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/invoicing-and-project-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/invoicing-and-project-management-software.vue")
  },
  {
    name: "solutions-invoicing-software-for-consultants",
    path: "/solutions/invoicing-software-for-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/invoicing-software-for-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/invoicing-software-for-consultants.vue")
  },
  {
    name: "solutions-marketing-agency-project-management-software",
    path: "/solutions/marketing-agency-project-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/marketing-agency-project-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/marketing-agency-project-management-software.vue")
  },
  {
    name: "solutions-missed-call-text-back-software",
    path: "/solutions/missed-call-text-back-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/missed-call-text-back-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/missed-call-text-back-software.vue")
  },
  {
    name: "solutions-msp-software",
    path: "/solutions/msp-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/msp-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/msp-software.vue")
  },
  {
    name: "solutions-nonprofit-software",
    path: "/solutions/nonprofit-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/nonprofit-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/nonprofit-software.vue")
  },
  {
    name: "solutions-payment-plan-software",
    path: "/solutions/payment-plan-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/payment-plan-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/payment-plan-software.vue")
  },
  {
    name: "solutions-payment-reminder-software",
    path: "/solutions/payment-reminder-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/payment-reminder-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/payment-reminder-software.vue")
  },
  {
    name: "solutions-personal-trainer-software",
    path: "/solutions/personal-trainer-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/personal-trainer-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/personal-trainer-software.vue")
  },
  {
    name: "solutions-photography-business-software",
    path: "/solutions/photography-business-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/photography-business-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/photography-business-software.vue")
  },
  {
    name: "solutions-pr-agency-software",
    path: "/solutions/pr-agency-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/pr-agency-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/pr-agency-software.vue")
  },
  {
    name: "solutions-professional-services-billing-software",
    path: "/solutions/professional-services-billing-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/professional-services-billing-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/professional-services-billing-software.vue")
  },
  {
    name: "solutions-project-profitability-software-for-agencies",
    path: "/solutions/project-profitability-software-for-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/project-profitability-software-for-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/project-profitability-software-for-agencies.vue")
  },
  {
    name: "solutions-proposal-software-for-agencies",
    path: "/solutions/proposal-software-for-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/proposal-software-for-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/proposal-software-for-agencies.vue")
  },
  {
    name: "solutions-proposal-software-for-consultants",
    path: "/solutions/proposal-software-for-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/proposal-software-for-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/proposal-software-for-consultants.vue")
  },
  {
    name: "solutions-proposal-software-for-freelancers",
    path: "/solutions/proposal-software-for-freelancers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/proposal-software-for-freelancers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/proposal-software-for-freelancers.vue")
  },
  {
    name: "solutions-proposal-tracking-software",
    path: "/solutions/proposal-tracking-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/proposal-tracking-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/proposal-tracking-software.vue")
  },
  {
    name: "solutions-retainer-billing-software-for-agencies",
    path: "/solutions/retainer-billing-software-for-agencies",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/retainer-billing-software-for-agencies"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/retainer-billing-software-for-agencies.vue")
  },
  {
    name: "solutions-salon-spa-software",
    path: "/solutions/salon-spa-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/salon-spa-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/salon-spa-software.vue")
  },
  {
    name: "solutions-scheduling-software-for-consultants",
    path: "/solutions/scheduling-software-for-consultants",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/scheduling-software-for-consultants"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/scheduling-software-for-consultants.vue")
  },
  {
    name: "solutions-seo-agency-management-software",
    path: "/solutions/seo-agency-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/seo-agency-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/seo-agency-management-software.vue")
  },
  {
    name: "solutions-service-business-management-software",
    path: "/solutions/service-business-management-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/service-business-management-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/service-business-management-software.vue")
  },
  {
    name: "solutions-shared-inbox-software",
    path: "/solutions/shared-inbox-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/shared-inbox-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/shared-inbox-software.vue")
  },
  {
    name: "solutions-sms-inbox-for-client-work",
    path: "/solutions/sms-inbox-for-client-work",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/sms-inbox-for-client-work"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/sms-inbox-for-client-work.vue")
  },
  {
    name: "solutions-time-tracking-and-invoicing-software",
    path: "/solutions/time-tracking-and-invoicing-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/time-tracking-and-invoicing-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/time-tracking-and-invoicing-software.vue")
  },
  {
    name: "solutions-travel-agency-software",
    path: "/solutions/travel-agency-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/travel-agency-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/travel-agency-software.vue")
  },
  {
    name: "solutions-tutoring-business-software",
    path: "/solutions/tutoring-business-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/tutoring-business-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/tutoring-business-software.vue")
  },
  {
    name: "solutions-video-production-software",
    path: "/solutions/video-production-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/video-production-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/video-production-software.vue")
  },
  {
    name: "solutions-web-design-agency-software",
    path: "/solutions/web-design-agency-software",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/web-design-agency-software"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/web-design-agency-software.vue")
  },
  {
    name: "solutions-workspace-crm",
    path: "/solutions/workspace-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions/workspace-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/workspace-crm.vue")
  },
  {
    name: "switch-17hats",
    path: "/switch/17hats",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/17hats"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/17hats.vue")
  },
  {
    name: "switch-accelo",
    path: "/switch/accelo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/accelo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/accelo.vue")
  },
  {
    name: "switch-asana",
    path: "/switch/asana",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/asana"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/asana.vue")
  },
  {
    name: "switch-basecamp",
    path: "/switch/basecamp",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/basecamp"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/basecamp.vue")
  },
  {
    name: "switch-bigin",
    path: "/switch/bigin",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/bigin"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/bigin.vue")
  },
  {
    name: "switch-bloom",
    path: "/switch/bloom",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/bloom"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/bloom.vue")
  },
  {
    name: "switch-bonsai",
    path: "/switch/bonsai",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/bonsai"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/bonsai.vue")
  },
  {
    name: "switch-capsule-crm",
    path: "/switch/capsule-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/capsule-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/capsule-crm.vue")
  },
  {
    name: "switch-clickup",
    path: "/switch/clickup",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/clickup"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/clickup.vue")
  },
  {
    name: "switch-copilot",
    path: "/switch/copilot",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/copilot"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/copilot.vue")
  },
  {
    name: "switch-dubsado",
    path: "/switch/dubsado",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/dubsado"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/dubsado.vue")
  },
  {
    name: "switch-freshbooks",
    path: "/switch/freshbooks",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/freshbooks"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/freshbooks.vue")
  },
  {
    name: "switch-gohighlevel",
    path: "/switch/gohighlevel",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/gohighlevel"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/gohighlevel.vue")
  },
  {
    name: "switch-harvest",
    path: "/switch/harvest",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/harvest"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/harvest.vue")
  },
  {
    name: "switch-honeybook",
    path: "/switch/honeybook",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/honeybook"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/honeybook.vue")
  },
  {
    name: "switch-hubspot",
    path: "/switch/hubspot",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/hubspot"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/hubspot.vue")
  },
  {
    name: "switch-insightly",
    path: "/switch/insightly",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/insightly"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/insightly.vue")
  },
  {
    name: "switch-keap",
    path: "/switch/keap",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/keap"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/keap.vue")
  },
  {
    name: "switch-less-annoying-crm",
    path: "/switch/less-annoying-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/less-annoying-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/less-annoying-crm.vue")
  },
  {
    name: "switch-monday-com",
    path: "/switch/monday-com",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/monday-com"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/monday-com.vue")
  },
  {
    name: "switch-moxie",
    path: "/switch/moxie",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/moxie"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/moxie.vue")
  },
  {
    name: "switch-notion",
    path: "/switch/notion",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/notion"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/notion.vue")
  },
  {
    name: "switch-paymo",
    path: "/switch/paymo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/paymo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/paymo.vue")
  },
  {
    name: "switch-pipedrive",
    path: "/switch/pipedrive",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/pipedrive"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/pipedrive.vue")
  },
  {
    name: "switch-plutio",
    path: "/switch/plutio",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/plutio"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/plutio.vue")
  },
  {
    name: "switch-productive",
    path: "/switch/productive",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/productive"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/productive.vue")
  },
  {
    name: "switch-quickbooks",
    path: "/switch/quickbooks",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/quickbooks"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/quickbooks.vue")
  },
  {
    name: "switch-quo",
    path: "/switch/quo",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/quo"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/quo.vue")
  },
  {
    name: "switch-scoro",
    path: "/switch/scoro",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/scoro"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/scoro.vue")
  },
  {
    name: "switch-smartsheet",
    path: "/switch/smartsheet",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/smartsheet"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/smartsheet.vue")
  },
  {
    name: "switch-suitedash",
    path: "/switch/suitedash",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/suitedash"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/suitedash.vue")
  },
  {
    name: "switch-teamwork",
    path: "/switch/teamwork",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/teamwork"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/teamwork.vue")
  },
  {
    name: "switch-trello",
    path: "/switch/trello",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/trello"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/trello.vue")
  },
  {
    name: "switch-wrike",
    path: "/switch/wrike",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/wrike"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/wrike.vue")
  },
  {
    name: "switch-zoho-crm",
    path: "/switch/zoho-crm",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/zoho-crm"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/zoho-crm.vue")
  },
  {
    name: "switch-zoho-one",
    path: "/switch/zoho-one",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/zoho-one"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/zoho-one.vue")
  },
  {
    name: "switch-zoho-projects",
    path: "/switch/zoho-projects",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch/zoho-projects"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/zoho-projects.vue")
  },
  {
    name: "tools-agency-capacity-planner",
    path: "/tools/agency-capacity-planner",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/agency-capacity-planner"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/agency-capacity-planner.vue")
  },
  {
    name: "tools-billable-utilization-calculator",
    path: "/tools/billable-utilization-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/billable-utilization-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/billable-utilization-calculator.vue")
  },
  {
    name: "tools-blank-invoice-template",
    path: "/tools/blank-invoice-template",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/blank-invoice-template"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/blank-invoice-template.vue")
  },
  {
    name: "tools-booking-page-generator",
    path: "/tools/booking-page-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/booking-page-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/booking-page-generator.vue")
  },
  {
    name: "tools-business-name-generator",
    path: "/tools/business-name-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/business-name-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/business-name-generator.vue")
  },
  {
    name: "tools-consulting-rate-calculator",
    path: "/tools/consulting-rate-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/consulting-rate-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/consulting-rate-calculator.vue")
  },
  {
    name: "tools-deposit-calculator",
    path: "/tools/deposit-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/deposit-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/deposit-calculator.vue")
  },
  {
    name: "tools-email-signature-generator",
    path: "/tools/email-signature-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/email-signature-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/email-signature-generator.vue")
  },
  {
    name: "tools-estimate-template",
    path: "/tools/estimate-template",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/estimate-template"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/estimate-template.vue")
  },
  {
    name: "tools-freelance-contract-template",
    path: "/tools/freelance-contract-template",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/freelance-contract-template"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/freelance-contract-template.vue")
  },
  {
    name: "tools-freelancer-bio-generator",
    path: "/tools/freelancer-bio-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/freelancer-bio-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/freelancer-bio-generator.vue")
  },
  {
    name: "tools-hourly-rate-calculator",
    path: "/tools/hourly-rate-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/hourly-rate-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/hourly-rate-calculator.vue")
  },
  {
    name: "tools-invoice-due-date-calculator",
    path: "/tools/invoice-due-date-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/invoice-due-date-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/invoice-due-date-calculator.vue")
  },
  {
    name: "tools-invoice-generator",
    path: "/tools/invoice-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/invoice-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/invoice-generator.vue")
  },
  {
    name: "tools-invoice-template",
    path: "/tools/invoice-template",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/invoice-template"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/invoice-template.vue")
  },
  {
    name: "tools-late-fee-calculator",
    path: "/tools/late-fee-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/late-fee-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/late-fee-calculator.vue")
  },
  {
    name: "tools-payment-processing-fee-calculator",
    path: "/tools/payment-processing-fee-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/payment-processing-fee-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/payment-processing-fee-calculator.vue")
  },
  {
    name: "tools-payment-reminder-generator",
    path: "/tools/payment-reminder-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/payment-reminder-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/payment-reminder-generator.vue")
  },
  {
    name: "tools-profit-margin-calculator",
    path: "/tools/profit-margin-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/profit-margin-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/profit-margin-calculator.vue")
  },
  {
    name: "tools-proposal-follow-up-generator",
    path: "/tools/proposal-follow-up-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/proposal-follow-up-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/proposal-follow-up-generator.vue")
  },
  {
    name: "tools-retainer-calculator",
    path: "/tools/retainer-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/retainer-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/retainer-calculator.vue")
  },
  {
    name: "tools-scope-change-request-generator",
    path: "/tools/scope-change-request-generator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/scope-change-request-generator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/scope-change-request-generator.vue")
  },
  {
    name: "tools-seo-deliverables-tracker",
    path: "/tools/seo-deliverables-tracker",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/seo-deliverables-tracker"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/seo-deliverables-tracker.vue")
  },
  {
    name: "tools-software-stack-cost-calculator",
    path: "/tools/software-stack-cost-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/software-stack-cost-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/software-stack-cost-calculator.vue")
  },
  {
    name: "tools-upwork-vs-fiverr-fee-calculator",
    path: "/tools/upwork-vs-fiverr-fee-calculator",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools/upwork-vs-fiverr-fee-calculator"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/upwork-vs-fiverr-fee-calculator.vue")
  },
  {
    name: "alternatives-slug",
    path: "/alternatives/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/alternatives/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/alternatives/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/blog/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/blog/[slug].vue")
  },
  {
    name: "changelog-slug",
    path: "/changelog/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/changelog/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/changelog/[slug].vue")
  },
  {
    name: "customers-slug",
    path: "/customers/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/customers/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/customers/[slug].vue")
  },
  {
    name: "integrations-slug",
    path: "/integrations/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/integrations/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/integrations/[slug].vue")
  },
  {
    name: "learn-slug",
    path: "/learn/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/learn/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/learn/[slug].vue")
  },
  {
    name: "research-slug",
    path: "/research/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/research/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/research/[slug].vue")
  },
  {
    name: "templates-slug",
    path: "/templates/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/templates/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/templates/[slug].vue")
  },
  {
    name: "tours-slug",
    path: "/tours/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tours/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tours/[slug].vue")
  },
  {
    name: "tutorials-slug",
    path: "/tutorials/:slug()",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tutorials/:slug()"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tutorials/[slug].vue")
  },
  {
    name: "about",
    path: "/about",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/about"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/about.vue")
  },
  {
    name: "acceptable-use",
    path: "/acceptable-use",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/acceptable-use"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/acceptable-use.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/accessibility"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/accessibility.vue")
  },
  {
    name: "affiliate",
    path: "/affiliate",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/affiliate"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/affiliate/index.vue")
  },
  {
    name: "ai",
    path: "/ai",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/ai"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/ai.vue")
  },
  {
    name: "alternatives",
    path: "/alternatives",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/alternatives"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/alternatives/index.vue")
  },
  {
    name: "app",
    path: "/app",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/app"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/app.vue")
  },
  {
    name: "blog",
    path: "/blog",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/blog"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/blog/index.vue")
  },
  {
    name: "build-a-crm-with-ai",
    path: "/build-a-crm-with-ai",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/build-a-crm-with-ai"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/build-a-crm-with-ai.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/changelog"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/changelog/index.vue")
  },
  {
    name: "community",
    path: "/community",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/community"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/community.vue")
  },
  {
    name: "compare",
    path: "/compare",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/compare"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/compare/index.vue")
  },
  {
    name: "contact-sales",
    path: "/contact-sales",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/contact-sales"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/contact-sales.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/cookie-policy"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/cookie-policy.vue")
  },
  {
    name: "customers",
    path: "/customers",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/customers"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/customers/index.vue")
  },
  {
    name: "dmca",
    path: "/dmca",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/dmca"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/dmca.vue")
  },
  {
    name: "dpa",
    path: "/dpa",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/dpa"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/dpa.vue")
  },
  {
    name: "features",
    path: "/features",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/features"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/features/index.vue")
  },
  {
    name: "find-a-freelancer",
    path: "/find-a-freelancer",
    meta: find_45a_45freelancer_KXfMwd14TQgARdUhpASk4qNnkLAcjMCfVG6uunbIJUMeta || {},
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/find-a-freelancer"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/find-a-freelancer.vue")
  },
  {
    name: "founding-lifetime-request",
    path: "/founding-lifetime-request",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/founding-lifetime-request"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/founding-lifetime-request.vue")
  },
  {
    name: "help-center",
    path: "/help-center",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/help-center"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/help-center.vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/integrations"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/integrations/index.vue")
  },
  {
    name: "ios",
    path: "/ios",
    meta: ios_Avr7Rfa95ZdQsghgOIszznf27kN_ksoWoka4T1RKQ8Meta || {},
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/ios"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/ios.vue")
  },
  {
    name: "learn",
    path: "/learn",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/learn"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/learn/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/legal"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/legal/index.vue")
  },
  {
    name: "press",
    path: "/press",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/press"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/press.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/pricing"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/pricing.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/privacy-policy"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/privacy-policy.vue")
  },
  {
    name: "refund-policy",
    path: "/refund-policy",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/refund-policy"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/refund-policy.vue")
  },
  {
    name: "research",
    path: "/research",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/research"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/research/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: index7h6hMeYllJ4MKbsMuR9BzU0k3O7Un_j7hDvJiP9yWZcMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/reset-password/index.vue")
  },
  {
    name: "roadmap",
    path: "/roadmap",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/roadmap"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/roadmap.vue")
  },
  {
    name: "security",
    path: "/security",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/security"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/security.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inozg1oansyfnPrNHRf5j40fjdlzvrHlN_ciKLd9ZoCKwMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sign-in.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: sign_45upuGcIjz5mi6FPyj3Kocqf9t_5mgRqAtXMF4Kq7_PWdWQMeta || {},
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sign-up.vue")
  },
  {
    name: "sms-terms",
    path: "/sms-terms",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/sms-terms"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sms-terms.vue")
  },
  {
    name: "solutions",
    path: "/solutions",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/solutions"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/solutions/index.vue")
  },
  {
    name: "start",
    path: "/start",
    meta: startUlto8hDMjrLCKJWGp2ggiL6iNv1cCMKQhpyOZ9RCNyMMeta || {},
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/start"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/start.vue")
  },
  {
    name: "sub-processors",
    path: "/sub-processors",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/sub-processors"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/sub-processors.vue")
  },
  {
    name: "support",
    path: "/support",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/support"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/support.vue")
  },
  {
    name: "switch",
    path: "/switch",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/switch"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/switch/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/templates"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/templates/index.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/terms-of-service"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/terms-of-service.vue")
  },
  {
    name: "tools",
    path: "/tools",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tools"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tools/index.vue")
  },
  {
    name: "tours",
    path: "/tours",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tours"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tours/index.vue")
  },
  {
    name: "trust",
    path: "/trust",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/trust"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/trust.vue")
  },
  {
    name: "try",
    path: "/try",
    meta: try4JfxhKQce3wktqrPI5VcaookC8jrNhLAf_bC5xGAXsoMeta || {},
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/try"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/try.vue")
  },
  {
    name: "tutorials",
    path: "/tutorials",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/tutorials"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/tutorials/index.vue")
  },
  {
    name: "what-is-workspace369",
    path: "/what-is-workspace369",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/what-is-workspace369"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/what-is-workspace369.vue")
  },
  {
    name: "why-workspace369",
    path: "/why-workspace369",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/why-workspace369"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/why-workspace369.vue")
  },
  {
    name: "workspace369-features",
    path: "/workspace369-features",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/workspace369-features"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/workspace369-features.vue")
  },
  {
    name: "workspace369-pricing",
    path: "/workspace369-pricing",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)/workspace369-pricing"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/workspace369-pricing.vue")
  },
  {
    name: "index",
    path: "/",
    alias: ["/:locale(ar|cs|de|el|es|fi|tl|fr|he|hu|id|it|ja|ko|ms|nl|pl|pt|ro|ru|sv|th|tr|uk|vi|zh-hant)"],
    component: () => import("/Users/szymon-mini-one/worktrees/landing-batch246-20261103/pages/index.vue")
  }
]